export const TREASURY = '/treasury/deposits';
export const TREASURY_CORRECTIONS = '/treasury/corrections';
export const TREASURY_INCOME = '/treasury/income';
export const ACCREDITATION_PROCESS = '/accreditations/process';
export const TREASURY_PROFORMA = '/treasury/elaborateProforma';
export const COMMON_POLITICAL_DIVISION = '/common/politicalDivision';